// import api from '../../api'
import * as types from '../mutation-types'

// initial state
const state = {
  isLoading: false,
  isAudioPlaying: false,
  fontSize: 'medium',
  footerTextColor: '#000'
}

// getters
const getters = {
  isAudioPlaying: state => state.isAudioPlaying,
  fontSize: state => state.fontSize,
  footerTextColor: state => state.footerTextColor
}

// actions
const actions = {

  setAudioStatus({ commit }, { playing }){
    commit(types.SET_AUDIO_STATUS, playing)
  },
  setFontSize({ commit }, { size }){
    commit(types.SET_FONT_SIIZE, size)
  },
  setFooterTextColor({ commit }, { color }){
    commit(types.SET_FOOTER_TEXT_COLOR, color)
  }

}

// mutations
const mutations = {

  [types.SET_AUDIO_STATUS] (state, val) {
    state.isAudioPlaying = val
  },

  [types.SET_FONT_SIIZE] (state, val) {
    state.fontSize = val
  },

  [types.SET_FOOTER_TEXT_COLOR] (state, val) {
    state.footerTextColor = val
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
